import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import UI from './UI';

const Container = styled(UI.Div)`
  ${({ theme }) => css`
    min-width: 320px;
    max-width: ${theme.breakpoints.md}px;
    margin: 0 auto;
    padding: ${theme.gutter * 0.75}px;

    @media ${theme.devices.md} {
      padding: ${theme.gutter * 1.5}px;
    }
  `}
`;

const NetworkError = () => {
  const { t } = useTranslation('common');

  return (
    <Container sc={{ py: 6 }}>
      <UI.H1 sc={{ mb: 2 }}>
        <UI.Span sc={{ color: 'secondary.900' }}>
          {t('network_error.network_error')}
        </UI.Span>
      </UI.H1>
      <UI.Paragraph sc={{ mb: 0 }}>
        {t('network_error.network_error_description')}
      </UI.Paragraph>
    </Container>
  );
};

export default NetworkError;
